import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBar from "@/components/site/TrustBar";
import LogoMarquee from "@/components/site/LogoMarquee";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import HowItWorks from "@/components/site/HowItWorks";
import Services from "@/components/site/Services";
import RatingChart from "@/components/site/RatingChart";
import Manifesto from "@/components/site/Manifesto";
import Ethics from "@/components/site/Ethics";
import Pricing from "@/components/site/Pricing";
import CalendlySection from "@/components/site/CalendlySection";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import AuditForm from "@/components/site/AuditForm";
import Footer from "@/components/site/Footer";
import ScrollProgress from "@/components/site/ScrollProgress";
import ChatWidget from "@/components/site/ChatWidget";
import SmoothScroll from "@/components/site/SmoothScroll";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import PaymentSuccessListener from "@/components/site/PaymentSuccessListener";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen bg-gh-navy text-white overflow-x-hidden font-body">
      <SmoothScroll />
      <ScrollProgress />
      <PaymentSuccessListener />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <LogoMarquee />
        <HowItWorks />
        <Services />
        <EditorialMarquee />
        <RatingChart />
        <Manifesto />
        <Ethics />
        <Pricing />
        <CalendlySection />
        <Testimonials />
        <FAQ />
        <AuditForm />
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
    </div>
  );
}
